import React from 'react';

import local from '../homeStyles/dar.module.css';

export const PRIORITY_INFO = (
    <div data-testid="priority-info">
        <p>
            <span className={`${local.redText}`}>Red Requests</span> - Potential data breach changes
            - Documents uploaded to the wrong record/Participant
        </p>
        <p>
            <span className={`${local.amberText}`}>Amber Requests</span> - Changes to
            placements/appointments that may be associated to a claim point
        </p>
        <p>
            <span className={`${local.greenText}`}>Green Requests</span> - General participant data
            changes i.e. NINOs
        </p>
    </div>
);
